import { PostalCodeCheckForm, VisuallyHidden, Text } from '@ads-core/components';

type ABTestSubmitButtonProps = {
  isTestVariant: boolean;
  children: React.ReactNode;
};

export const ABTestSubmitButton = ({ isTestVariant, children }: ABTestSubmitButtonProps) => {
  return (
    <>
      <PostalCodeCheckForm.SubmitButton
        disabled={isTestVariant}
        aria-describedby={isTestVariant ? 'network-check-submit-helper' : undefined}
        size="large"
        tone="onDark"
        variant="secondary"
      >
        {children}
      </PostalCodeCheckForm.SubmitButton>
      {isTestVariant ? (
        <VisuallyHidden id="network-check-submit-helper">
          <Text>Vul alle verplichte velden in om het formulier te versturen.</Text>
        </VisuallyHidden>
      ) : null}
    </>
  );
};
